import {
  DeepRequired,
  FieldErrorsImpl,
  UseFormRegister,
  UseFormSetValue,
} from "react-hook-form";
import { Portal } from "../../components";
import { useCheckoutPage } from "../../hooks";
import {
  IInitPaymentLinkTransactionRequest,
  IViewPaymentLink,
} from "../../interfaces-and-types";
import { SaleLineItemQuantityEditor } from "./SaleLineItemQuantityEditor";

interface ISaleLineItemsProps {
  saleTotal: number;
  hostedPaymentLink: IViewPaymentLink;
  isLineItemQtyInputTempDisabled: boolean;
  setValue: UseFormSetValue<IInitPaymentLinkTransactionRequest>; //(value: any) => void;
  register: UseFormRegister<IInitPaymentLinkTransactionRequest>;
  errors: FieldErrorsImpl<DeepRequired<IInitPaymentLinkTransactionRequest>>;
}

export const SaleLineItems = ({
  hostedPaymentLink,
  isLineItemQtyInputTempDisabled,
  setValue,
  errors,
  register,
}: ISaleLineItemsProps) => {
  const { searchLineItemsText, line_items } = useCheckoutPage();

  return (
    <>
      <Portal portalRoot="sale-items-portal">
        {searchLineItemsText &&
        hostedPaymentLink.line_items.find((lineItem) =>
          lineItem.product_name
            .toLocaleLowerCase()
            .includes(searchLineItemsText?.toLocaleLowerCase())
        ) === undefined ? (
          <div className="switchapp-small mt-5 mb-5">
            No products match the search criteria...{" "}
          </div>
        ) : null}

        {line_items.map((lineItem, index) => {
          return (
            <SaleLineItemQuantityEditor
              key={lineItem.product}
              index={index}
              paymentLinkLineItem={
                hostedPaymentLink.line_items.find(
                  (pl) => pl.product == lineItem.product
                )!
              }
              saleLineItem={lineItem}
              isInputDisabled={isLineItemQtyInputTempDisabled}
              setValue={setValue}
              register={register}
              errors={errors}
            />
          );
        })}
      </Portal>
    </>
  );
};
